<eess-bienvenido></eess-bienvenido>
<div class="bch-card ml-3 col-lg-8 col-md-11 mx-auto col-xl-8">
    <div class="mb-4">
        <h4 class="ta-c">
            <img src="assets/images/person-pen.svg" width="100" height="100" />
        </h4>
    </div>
    <div class="row fd-c jc-c">
        <div class="pb-4 ta-c col-sm-11 mx-auto">
            <p class="c-brand ta-c text--medium info">
                Con la finalidad de poder <b>ofrecerte productos y servicios bancarios y de nuestras filiales a tu
                    medida</b>, necesitamos conocer cuál es tu situación financiera, por esto te invitamos a
                completar y enviar tu Estado de Situación.
            </p>
        </div>
        <div class="col-12 col-xl-4 col-sm-8 col-md-6 mx-auto bch-button-auto-size">
            <bch-button [button]="buttonComenzar" (click)="cambiarFormulario()"></bch-button>
        </div>
    </div>
</div>